import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ActionsCompletedPluginService } from './actions-completed-plugin.service';

@Component({
  selector: 'actions-completed',
  templateUrl: './actions-completed.component.html',
  standalone: false
})
export class ActionsCompletedPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public actions: any[];

  constructor(
    public actionsCompletedService: ActionsCompletedPluginService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.actions = this.plugin.config.Actions;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'actionscompleted',
      'edit'
    ];
  }
}

PluginComponent.plugins['actionscompleted'] = ActionsCompletedPluginComponent;
